require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./prvention-et-sant-1-9-2.json") })
        }
      }, "path---prvention-et-sant-1-9-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---prvention-et-sant-1-9-2!./.cache/json/prvention-et-sant-1-9-2.json
// module id = 542
// module chunks = 231608221292675